import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as category from '../category'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: category.RESOURCE.payload.dimension.partialId,
      partialId: category.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description: 'Does this category represent a sponsored activity?',
    isOptional: false,
    name: 'Is Sponsored?',
    partialId: PartialId.Standard.create('is_sponsored'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
